/**
 * Given two ranges [x1,x2], [y1,y2] return a boolean true if ranges overlap
 */

export const isOverlapped = (x1, x2, y1, y2) => Math.max(x1, y1) <= Math.min(x2, y2);
